module.exports = __webpack_public_path__ + "img/TA:supervisor.59d58353.png";